// (c) Copyright 2009 Jaded Pixel. Author: Caroline Schnapp. All Rights Reserved.

/*

IMPORTANT:

Ajax requests that update Shopify's cart must be queued and sent synchronously to the server.
Meaning: you must wait for your 1st ajax callback to send your 2nd request, and then wait
for its callback to send your 3rd request, etc.

*/

/**
 *
 * Updated to Live Version on October 2, 2013 by Spencer Norman
 *
 */

/**
 * Modified by Mitchell Amihod
 *  We make some mods. consider them feedback :) See comments/commit messages
 * Changes include:
 *      addItemFromForm: allow for passing in of form element, OR string selector
 *      updateCartFromForm: allow for passing in of form element, OR string selector
 *
 * To see how I make use of these changes, see [link to ajaxify-shop.js]
 *
 * Sept 02, 2010
 */
if ((typeof Shopify) === 'undefined') {
    Shopify = {};
}

/* 

Override so that Shopify.formatMoney returns pretty
money values instead of cents.

*/

Shopify.money_format = '$ {{amount}}';

/* 

Events (override!)

Example override:
  ... add to your theme.liquid's script tag....

  Shopify.onItemAdded = function(line_item) {
    $('message').update('Added '+line_item.title + '...');
  }
  
*/

Shopify.onError = function (XMLHttpRequest, textStatus) {
    // Shopify returns a description of the error in XMLHttpRequest.responseText.
    // It is JSON.
    // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
        alert(data.message + '(' + data.status + '): ' + data.description);
    } else {
        alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
    }
};

Shopify.fullMessagesFromErrors = function (errors) {
    var fullMessages = [];
    jQuery.each(errors, function (attribute, messages) {
        jQuery.each(messages, function (index, message) {
            fullMessages.push(attribute + ' ' + message);
        });
    });
    return fullMessages
}

Shopify.onCartUpdate = function (cart) {
    alert('There are now ' + cart.item_count + ' items in the cart.');
};

Shopify.onCartShippingRatesUpdate = function (rates, shipping_address) {
    var readable_address = '';
    if (shipping_address.zip) readable_address += shipping_address.zip + ', ';
    if (shipping_address.province) readable_address += shipping_address.province + ', ';
    readable_address += shipping_address.country
    alert('There are ' + rates.length + ' shipping rates available for ' + readable_address + ', starting at ' + Shopify.formatMoney(rates[0].price) + '.');
};

Shopify.onItemAdded = function (line_item) {
    alert(line_item.title + ' was added to your shopping cart.');
};

Shopify.onProduct = function (product) {
    alert('Received everything we ever wanted to know about ' + product.title);
};

/* Tools */

/* 
Examples of call:
Shopify.formatMoney(600000, '&euro;{{amount_with_comma_separator}} EUR')
Shopify.formatMoney(600000, '&euro;{{amount}} EUR')
Shopify.formatMoney(600000, '${{amount_no_decimals}}')
Shopify.formatMoney(600000, '{{ shop.money_format }}') in a Liquid template!

In a Liquid template, you have access to a shop money formats with:
{{ shop.money_format }}
{{ shop.money_with_currency_format }}
{{ shop.money_without_currency_format }}
All these formats are editable on the Preferences page in your admin.
*/
Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') cents = cents.replace('.', '');
    var value = '';
    var patt = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function addCommas(moneyString) {
        return moneyString.replace(/(\d+)(\d{3}[\.,]?)/, '$1,$2');
    }

    switch (formatString.match(patt)[1]) {
        case 'amount':
            value = addCommas(floatToString(cents / 100.0, 2));
            break;
        case 'amount_no_decimals':
            value = addCommas(floatToString(cents / 100.0, 0));
            break;
        case 'amount_with_comma_separator':
            value = floatToString(cents / 100.0, 2).replace(/\./, ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = addCommas(floatToString(cents / 100.0, 0)).replace(/\./, ',');
            break;
    }
    return formatString.replace(patt, value);
};

Shopify.resizeImage = function (image, size) {
    try {
        if (size == 'original') {
            return image;
        } else {
            var matches = image.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
            return matches[1] + '_' + size + '.' + matches[2];
        }
    } catch (e) {
        return image;
    }
};

/* Ajax API */

// -------------------------------------------------------------------------------------
// POST to cart/add.js returns the JSON of the line item associated with the added item.
// -------------------------------------------------------------------------------------
Shopify.addItem = function (variant_id, quantity, callback) {
    quantity = quantity || 1;
    var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: 'quantity=' + quantity + '&id=' + variant_id,
        dataType: 'json',
        success: function (line_item) {
            if ((typeof callback) === 'function') {
                callback(line_item);
            } else {
                Shopify.onItemAdded(line_item);
            }
        },
        error: function (XMLHttpRequest, textStatus) {
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    };
    jQuery.ajax(params);
};

// ---------------------------------------------------------
// POST to cart/add.js returns the JSON of the line item.
// ---------------------------------------------------------
//Allow use of form element instead of id.
//This makes it a bit more flexible. Every form doesn't need an id.
//Once you are having someone pass in an id, might as well make it selector based, or pass in the element itself.
//Since you are just wrapping it in a jq(). The same rationale is behind the change for updateCartFromForm
//@param HTMLElement the form element which was submitted. Or you could pass in a string selector such as the form id. 
//@param function callback callback fuction if you like, but I just override Shopify.onItemAdded() instead
// Vendor exception configuration
// Products/SKUs that are allowed to be added with specific vendors
var VENDOR_EXCEPTIONS = {
    'QW100LV': { // QuietWalk LV
        allowedVendors: ['floorlife', 'mohawk', 'shaw', 'coretec', 'anderson']
    }
    // Add more exceptions here as needed:
    // 'SKU123': {
    //     allowedVendors: ['vendor1', 'vendor2']
    // }
};

// Allowed vendor combinations (e.g. Laticrete + TIER Systems can coexist)
var ALLOWED_VENDOR_COMBINATIONS = [
    ['laticrete', 'tier systems']
];

// Helper function to check if a vendor combination is allowed based on exceptions
function isVendorCombinationAllowed(cartItems, newProductVendor, newProductSku) {
    // Normalize vendor names to lowercase for comparison
    var newVendorLower = String(newProductVendor || '').trim().toLowerCase();
    var newSku = String(newProductSku || '').trim().toUpperCase();
    
    // Collect all vendors and SKUs from cart
    var cartVendors = new Set();
    var cartSkus = new Set();
    
    if (cartItems && cartItems.length > 0) {
        for (var i = 0; i < cartItems.length; i++) {
            var itemVendor = String(cartItems[i].vendor || 
                             cartItems[i].product_vendor || 
                             (cartItems[i].product && cartItems[i].product.vendor) ||
                             '').trim().toLowerCase();
            if (itemVendor) {
                cartVendors.add(itemVendor);
            }
            
            var itemSku = String(cartItems[i].sku || '').trim().toUpperCase();
            if (itemSku) {
                cartSkus.add(itemSku);
            }
        }
    }
    
    // Add new product to the sets for validation
    if (newVendorLower) {
        cartVendors.add(newVendorLower);
    }
    if (newSku) {
        cartSkus.add(newSku);
    }
    
    // Check if any exception product is in cart (including the new product)
    var hasExceptionProduct = false;
    var exceptionAllowedVendors = null;
    
    // Check if new product is an exception
    if (newSku && VENDOR_EXCEPTIONS[newSku]) {
        hasExceptionProduct = true;
        exceptionAllowedVendors = VENDOR_EXCEPTIONS[newSku].allowedVendors.map(function(v) {
            return v.toLowerCase();
        });
    }
    
    // Check if any existing cart item is an exception
    cartSkus.forEach(function(sku) {
        if (VENDOR_EXCEPTIONS[sku]) {
            hasExceptionProduct = true;
            var allowed = VENDOR_EXCEPTIONS[sku].allowedVendors.map(function(v) {
                return v.toLowerCase();
            });
            // Merge allowed vendors (union)
            if (!exceptionAllowedVendors) {
                exceptionAllowedVendors = allowed;
            } else {
                exceptionAllowedVendors = exceptionAllowedVendors.filter(function(v) {
                    return allowed.indexOf(v) !== -1;
                });
            }
        }
    });
    
    // If we have an exception product, validate against allowed vendors
    if (hasExceptionProduct && exceptionAllowedVendors) {
        // Find the vendor(s) of exception products
        var exceptionProductVendors = new Set();
        cartSkus.forEach(function(sku) {
            if (VENDOR_EXCEPTIONS[sku]) {
                // Find the vendor of this exception product
                for (var j = 0; j < cartItems.length; j++) {
                    var itemSku = String(cartItems[j].sku || '').trim().toUpperCase();
                    if (itemSku === sku) {
                        var itemVendor = String(cartItems[j].vendor || 
                                         cartItems[j].product_vendor || 
                                         (cartItems[j].product && cartItems[j].product.vendor) ||
                                         '').trim().toLowerCase();
                        if (itemVendor) {
                            exceptionProductVendors.add(itemVendor);
                        }
                    }
                }
            }
        });
        
        // Also check new product if it's an exception
        if (newSku && VENDOR_EXCEPTIONS[newSku] && newVendorLower) {
            exceptionProductVendors.add(newVendorLower);
        }
        
        // All vendors in cart must be either:
        // 1. The vendor of an exception product, OR
        // 2. In the allowed vendors list
        var allVendorsAllowed = true;
        cartVendors.forEach(function(vendor) {
            var isExceptionVendor = exceptionProductVendors.has(vendor);
            var isAllowedVendor = exceptionAllowedVendors.indexOf(vendor) !== -1;
            if (!isExceptionVendor && !isAllowedVendor) {
                allVendorsAllowed = false;
            }
        });
        return allVendorsAllowed;
    }
    
    // If cart vendors are a subset of an allowed combination, allow
    for (var k = 0; k < ALLOWED_VENDOR_COMBINATIONS.length; k++) {
        var allowedSet = ALLOWED_VENDOR_COMBINATIONS[k];
        var allInSet = true;
        cartVendors.forEach(function(v) {
            if (allowedSet.indexOf(v) === -1) {
                allInSet = false;
            }
        });
        if (allInSet && cartVendors.size > 0) {
            return true;
        }
    }
    
    // No exception products - use standard single-vendor rule
    return cartVendors.size <= 1;
}

Shopify.addItemFromForm = function (form, callback) {
    // Get vendor and SKU from form data attribute
    var $form = jQuery(form);
    var newProductVendor = $form.data('product-vendor');
    
    // Check quote tag validation first - products with quote_auto or quote_phone cannot be added to cart
    var hasQuoteAuto = $form.data('has-quote-auto');
    var hasQuotePhone = $form.data('has-quote-phone');
    
    // Convert string "true"/"false" to boolean for comparison
    var isQuoteAuto = hasQuoteAuto === true || hasQuoteAuto === 'true' || String(hasQuoteAuto).toLowerCase() === 'true';
    var isQuotePhone = hasQuotePhone === true || hasQuotePhone === 'true' || String(hasQuotePhone).toLowerCase() === 'true';
    
    if (isQuoteAuto || isQuotePhone) {
        var quoteErrorMessage = 'This product requires a quote. Please use the quote request button or call 1-877-357-9663.';
        alert(quoteErrorMessage);
        
        // Re-enable the add to cart button
        $form.find('input[type="submit"], button[type="submit"]').attr('disabled', false).removeClass('disabled');
        
        if (typeof Shopify.onError === 'function') {
            Shopify.onError({status: 400, responseText: quoteErrorMessage}, 'quote_validation_failed');
        }
        return;
    }
    
    // Get selected variant SKU from the form
    var newProductSku = null;
    var variantSelect = $form.find('select[name="id"], #product-select-' + $form.data('product-id'));
    if (variantSelect.length > 0) {
        var selectedOption = variantSelect.find('option:selected');
        if (selectedOption.length > 0) {
            var skuValue = selectedOption.data('sku') || selectedOption.attr('data-sku') || null;
            // Ensure SKU is a string (data() might return a number)
            newProductSku = skuValue != null ? String(skuValue) : null;
        }
    }
    
    // If vendor data is available, validate before adding
    if (newProductVendor && newProductVendor.trim() !== '') {
        // Get current cart to check existing vendors
        jQuery.getJSON('/cart.js', function (cart) {
            // Use exception-aware validation
            if (!isVendorCombinationAllowed(cart.items || [], newProductVendor, newProductSku)) {
                var errorMessage = 'Your cart includes multiple vendors. Free shipping over $1,500 applies only to single-vendor orders. Remove other vendors or call 877-357-9663 for multi-vendor assistance.';
                alert(errorMessage);
                
                // Re-enable the add to cart button
                $form.find('input[type="submit"], button[type="submit"]').attr('disabled', false).removeClass('disabled');
                
                if (typeof Shopify.onError === 'function') {
                    Shopify.onError({status: 400, responseText: errorMessage}, 'vendor_validation_failed');
                }
                return;
            }
            
            // Validation passed, proceed with adding to cart
            var params = {
                type: 'POST',
                url: '/cart/add.js',
                data: $form.serialize(),
                dataType: 'json',
                success: function (line_item) {
                    if ((typeof callback) === 'function') {
                        callback(line_item, form);
                    } else {
                        Shopify.onItemAdded(line_item, form);
                    }
                },
                error: function (XMLHttpRequest, textStatus) {
                    Shopify.onError(XMLHttpRequest, textStatus);
                }
            };
            jQuery.ajax(params);
        });
    } else {
        // No vendor data available, proceed with normal add (for backwards compatibility)
        var params = {
            type: 'POST',
            url: '/cart/add.js',
            data: $form.serialize(),
            dataType: 'json',
            success: function (line_item) {
                if ((typeof callback) === 'function') {
                    callback(line_item, form);
                } else {
                    Shopify.onItemAdded(line_item, form);
                }
            },
            error: function (XMLHttpRequest, textStatus) {
                Shopify.onError(XMLHttpRequest, textStatus);
            }
        };
        jQuery.ajax(params);
    }
};

// ---------------------------------------------------------
// GET cart.js returns the cart in JSON.
// ---------------------------------------------------------
Shopify.getCart = function (callback) {
    jQuery.getJSON('/cart.js', function (cart, textStatus) {
        if ((typeof callback) === 'function') {
            callback(cart);
        } else {
            Shopify.onCartUpdate(cart);
        }
    });
};

// ---------------------------------------------------------
// GET cart/shipping_rates.js returns the cart in JSON.
// ---------------------------------------------------------
Shopify.getCartShippingRatesForDestination = function (shipping_address, callback) {
    var params = {
        type: 'GET',
        url: '/cart/shipping_rates.json',
        data: Shopify.param({'shipping_address': shipping_address}),
        dataType: 'json',
        success: function (response) {
            rates = response.shipping_rates
            if ((typeof callback) === 'function') {
                callback(rates, shipping_address);
            } else {
                Shopify.onCartShippingRatesUpdate(rates, shipping_address);
            }
        },
        error: function (XMLHttpRequest, textStatus) {
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    }
    jQuery.ajax(params);
};

// ---------------------------------------------------------
// GET products/<product-handle>.js returns the product in JSON.
// ---------------------------------------------------------
Shopify.getProduct = function (handle, callback) {
    jQuery.getJSON('/products/' + handle + '.js', function (product, textStatus) {
        if ((typeof callback) === 'function') {
            callback(product);
        } else {
            Shopify.onProduct(product);
        }
    });
};

// ---------------------------------------------------------
// POST to cart/change.js returns the cart in JSON.
// ---------------------------------------------------------
Shopify.changeItem = function (variant_id, quantity, callback) {
    var params = {
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&id=' + variant_id,
        dataType: 'json',
        success: function (cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                Shopify.onCartUpdate(cart);
            }
        },
        error: function (XMLHttpRequest, textStatus) {
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    };
    jQuery.ajax(params);
};

// ---------------------------------------------------------
// POST to cart/change.js returns the cart in JSON.
// ---------------------------------------------------------
Shopify.removeItem = function (variant_id, callback) {
    var params = {
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=0&id=' + variant_id,
        dataType: 'json',
        success: function (cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                Shopify.onCartUpdate(cart);
            }
        },
        error: function (XMLHttpRequest, textStatus) {
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    };
    jQuery.ajax(params);
};

// ---------------------------------------------------------
// POST to cart/clear.js returns the cart in JSON.
// It removes all the items in the cart, but does
// not clear the cart attributes nor the cart note.
// ---------------------------------------------------------
Shopify.clear = function (callback) {
    var params = {
        type: 'POST',
        url: '/cart/clear.js',
        data: '',
        dataType: 'json',
        success: function (cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                Shopify.onCartUpdate(cart);
            }
        },
        error: function (XMLHttpRequest, textStatus) {
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    };
    jQuery.ajax(params);
};

// ---------------------------------------------------------
// POST to cart/update.js returns the cart in JSON.
// ---------------------------------------------------------
//Allow use of form element instead of id.
//This makes it a bit more flexible. Every form doesn't need an id.
//Once you are having someone pass in an id, might as well make it selector based, or pass in the element itself, 
//since you are just wrapping it in a jq().
//@param HTMLElement the form element which was submitted. Or you could pass in a string selector such as the #form_id. 
//@param function callback callback fuction if you like, but I just override Shopify.onCartUpdate() instead
Shopify.updateCartFromForm = function (form, callback) {
    var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: jQuery(form).serialize(),
        dataType: 'json',
        success: function (cart) {
            if ((typeof callback) === 'function') {
                callback(cart, form);
            } else {
                Shopify.onCartUpdate(cart, form);
            }
        },
        error: function (XMLHttpRequest, textStatus) {
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    };
    jQuery.ajax(params);
};

// ---------------------------------------------------------
// POST to cart/update.js returns the cart in JSON.
// To clear a particular attribute, set its value to an empty string.
// Receives attributes as a hash or array. Look at comments below.
// ---------------------------------------------------------
Shopify.updateCartAttributes = function (attributes, callback) {
    var data = '';
    // If attributes is an array of the form:
    // [ { key: 'my key', value: 'my value' }, ... ]
    if (jQuery.isArray(attributes)) {
        jQuery.each(attributes, function (indexInArray, valueOfElement) {
            var key = attributeToString(valueOfElement.key);
            if (key !== '') {
                data += 'attributes[' + key + ']=' + attributeToString(valueOfElement.value) + '&';
            }
        });
    }
        // If attributes is a hash of the form:
    // { 'my key' : 'my value', ... }
    else if ((typeof attributes === 'object') && attributes !== null) {
        jQuery.each(attributes, function (key, value) {
            data += 'attributes[' + attributeToString(key) + ']=' + attributeToString(value) + '&';
        });
    }
    var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function (cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                Shopify.onCartUpdate(cart);
            }
        },
        error: function (XMLHttpRequest, textStatus) {
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    };
    jQuery.ajax(params);
};

// ---------------------------------------------------------
// POST to cart/update.js returns the cart in JSON.
// ---------------------------------------------------------
Shopify.updateCartNote = function (note, callback) {
    var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'note=' + attributeToString(note),
        dataType: 'json',
        success: function (cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                Shopify.onCartUpdate(cart);
            }
        },
        error: function (XMLHttpRequest, textStatus) {
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    };
    jQuery.ajax(params);
};


if (jQuery.fn.jquery >= '1.4') {
    Shopify.param = jQuery.param;
} else {
    Shopify.param = function (a) {
        var s = [],
            add = function (key, value) {
                // If value is a function, invoke it and return its value
                value = jQuery.isFunction(value) ? value() : value;
                s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value);
            };

        // If an array was passed in, assume that it is an array of form elements.
        if (jQuery.isArray(a) || a.jquery) {
            // Serialize the form elements
            jQuery.each(a, function () {
                add(this.name, this.value);
            });

        } else {
            for (var prefix in a) {
                Shopify.buildParams(prefix, a[prefix], add);
            }
        }

        // Return the resulting serialization
        return s.join("&").replace(/%20/g, "+");
    }

    Shopify.buildParams = function (prefix, obj, add) {
        if (jQuery.isArray(obj) && obj.length) {
            // Serialize array item.
            jQuery.each(obj, function (i, v) {
                if (rbracket.test(prefix)) {
                    // Treat each array item as a scalar.
                    add(prefix, v);

                } else {
                    Shopify.buildParams(prefix + "[" + (typeof v === "object" || jQuery.isArray(v) ? i : "") + "]", v, add);
                }
            });

        } else if (obj != null && typeof obj === "object") {
            if (Shopify.isEmptyObject(obj)) {
                add(prefix, "");

                // Serialize object item.
            } else {
                jQuery.each(obj, function (k, v) {
                    Shopify.buildParams(prefix + "[" + k + "]", v, add);
                });
            }

        } else {
            // Serialize scalar item.
            add(prefix, obj);
        }
    }

    Shopify.isEmptyObject = function (obj) {
        for (var name in obj) {
            return false;
        }
        return true;
    }
}


/* Used by Tools */

function floatToString(numeric, decimals) {
    var amount = numeric.toFixed(decimals).toString();
    if (amount.match(/^\.\d+/)) {
        return "0" + amount;
    } else {
        return amount;
    }
}

/* Used by API */

function attributeToString(attribute) {
    if ((typeof attribute) !== 'string') {
        // Converts to a string.
        attribute += '';
        if (attribute === 'undefined') {
            attribute = '';
        }
    }
    // Removing leading and trailing whitespace.
    return jQuery.trim(attribute);
}
